module.exports = __webpack_public_path__ + "static/img/2.bb53977.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/pinterest/2.jpeg
// module id = Cj89
// module chunks = 46